/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import {
  StyleSheet,
  View,
  TouchableOpacity,
  ScrollView,
  Dimensions,
} from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Modal from '@components/modal/Modal';
import Image from '@components/global/Image';
import Colors from '@global/colors';
import { isWeb, isMobileWeb, isNative } from '@global/screens';
import { Portal, PortalHost } from '@gorhom/portal';

const dimension = Dimensions.get('window');

const SociollaDatePicker = (props) => {
  const { testID = 'date-picker' } = props;
  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const [selected, setSelected] = useState(
    props.value ? props.value : new Date(),
  );
  const [fulldate, setFullDate] = useState(
    props.value ? props.value : new Date(),
  );
  const [showYearList, setShowYearList] = useState(false);
  const [dateHeight, setDateHeight] = useState(30);
  const [dateHeightChanged, setDateHeightChanged] = useState(false);
  const [lists, setLists] = useState([[], [], [], [], [], [], []]);
  const arrowSize = {
    width: 8,
    height: 12,
  };

  let start_year = 2012;
  const end_year = new Date().getFullYear() + 10;
  const years = [];
  while (start_year <= end_year) {
    years.push(start_year++);
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const dates = [[], [], [], [], [], [], []];
      let index = 0;
      const start_date_month = new Date(
        fulldate.getFullYear(),
        fulldate.getMonth(),
        1,
      );
      const end_date_month = new Date(
        fulldate.getFullYear(),
        fulldate.getMonth() + 1,
        0,
      );
      for (let i = 0; i < start_date_month.getDay(); i++) {
        dates[0].push('');
      }
      for (let i = 0; i < end_date_month.getDate(); i++) {
        const date = new Date(
          fulldate.getFullYear(),
          fulldate.getMonth(),
          i + 1,
        );
        dates[index].push(date);
        if (dates[index].length >= 7) {
          index = index + 1;
        }
      }
      setLists(dates);
    }
    return () => {
      mounted = false;
    };
  }, [fulldate]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setSelected(props.value);
      setFullDate(props.value);
    }
    return () => {
      mounted = false;
    };
  }, [props.value]);

  const onClose = () => {
    try {
      props.onClose();
    } catch (error) {}
  };

  const onChange = () => {
    try {
      props.onChange(selected);
    } catch (error) {}
  };

  const onLayoutItem = (e) => {
    try {
      setTimeout(() => {
        if (!dateHeightChanged && !isNative) {
          setDateHeightChanged(true);
          setDateHeight(e.nativeEvent.target.clientWidth);
        }
      }, 500);
    } catch (error) {}
  };

  const openByYear = (year) => {
    setFullDate(new Date(year, fulldate.getMonth(), fulldate.getDate()));
    setShowYearList(false);
  };

  const onPrev = () => {
    setFullDate(
      new Date(
        fulldate.getFullYear(),
        fulldate.getMonth() - 1,
        fulldate.getDate(),
      ),
    );
  };

  const onNext = () => {
    setFullDate(
      new Date(
        fulldate.getFullYear(),
        fulldate.getMonth() + 1,
        fulldate.getDate(),
      ),
    );
  };

  const checkDate = (value, type = 'getDate', no_value = false) =>
    value ? value[type]() : no_value ? '' : '-';

  const isDisableDate = (result) => {
    if (!result) {
      return;
    }
    const selectedDate = new Date(
      result.getFullYear(),
      result.getMonth(),
      checkDate(result),
    );
    if (props.disablePastDates) {
      const todayDate = new Date(new Date().toDateString());
      if (selectedDate < todayDate) {
        return true;
      }
    }
    if (props.disableBeforeDate) {
      const d = new Date(props.disableBeforeDate);
      const dateValue = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      if (selectedDate < dateValue) {
        return true;
      }
    }
    if (props.disableAfterDate) {
      const d = new Date(props.disableAfterDate);
      const dateValue = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      if (selectedDate > dateValue) {
        return true;
      }
    }
    return false;
  };

  const isToday = (value) => {
    if (!value) {
      return false;
    }
    const now = new Date();
    return (
      checkDate(value) == now.getDate() &&
      checkDate(value, 'getMonth') == now.getMonth() &&
      checkDate(value, 'getFullYear') == now.getFullYear()
    );
  };

  const isActive = (value) => {
    const date = checkDate(value);
    const month = checkDate(value, 'getMonth');
    const year = checkDate(value, 'getFullYear');
    return (
      selected.getDate() == date &&
      selected.getMonth() == month &&
      selected.getFullYear() == year
    );
  };

  return (
    <Modal
      testID={`${testID}-modal`}
      visible={props.visible}
      transparent={true}
      animationType="slide"
      spaceFromTop={'10%'}
      maxWidth={isWeb ? 250 : isMobileWeb ? 'calc(100% - 30px)' : 230}
      onClose={() => onClose()}>
      <View style={styles.datepicker}>
        {/* Top Date Detail Container */}
        <View style={styles.datepickerTop}>
          {/* Year Container */}
          <View>
            <TouchableOpacity
              testID={`${testID}-year-btn`}
              activeOpacity={0.6}
              style={styles.yearContainer}
              onPress={() => setShowYearList(true)}>
              <SociollaText type="bold" style={styles.yearText}>
                {fulldate.getFullYear()}
              </SociollaText>
            </TouchableOpacity>
            {showYearList ? (
              <Portal hostName="portal_year">
                <View
                  style={{
                    position: 'absolute',
                    maxHeight: 150,
                    left: 15,
                    top: 25,
                    backgroundColor: Colors.white,
                    zIndex: 9,
                    elevation: 99,
                    borderWidth: 1,
                    borderColor: Colors.grey0,
                    borderRadius: 4,
                  }}>
                  <ScrollView>
                    {years.map((item, idx) => (
                      <TouchableOpacity
                        testID={`${testID}-year-${item}`}
                        key={idx}
                        activeOpacity={0.6}
                        style={{
                          paddingHorizontal: 10,
                          paddingVertical: 5,
                          borderBottomWidth: 1,
                          borderBottomColor: Colors.grey0,
                        }}
                        onPress={() => openByYear(item)}>
                        <SociollaText type="bold" style={{ fontSize: 14 }}>
                          {item}
                        </SociollaText>
                      </TouchableOpacity>
                    ))}
                  </ScrollView>
                </View>
              </Portal>
            ) : (
              false
            )}
          </View>
          {/* Full Date Container */}
          <SociollaText type="bold" style={styles.dateText}>
            {days[selected.getDay()]}, {selected.getDate()}{' '}
            {monthNames[selected.getMonth()]}
          </SociollaText>
        </View>

        {/* Change Month Container */}
        <View
          style={[
            styles.rowContainer,
            {
              justifyContent: 'space-between',
              paddingHorizontal: isNative ? 25 : 15,
              paddingTop: 15,
              paddingBottom: 10,
            },
          ]}>
          <TouchableOpacity
            testID={`${testID}-prev-month-btn`}
            style={{
              width: 20,
              minWidth: 20,
              height: 14,
              paddingRight: 10,
            }}
            activeOpacity={0.6}
            onPress={() => onPrev()}>
            <Image
              style={arrowSize}
              width={arrowSize.width}
              height={arrowSize.height}
              svg={true}
              source={require('@assets/img/icons/arrow-left-grey.svg')}
            />
          </TouchableOpacity>
          <SociollaText
            style={{
              fontSize: 12,
              color: Colors.black,
            }}>
            {monthNames[fulldate.getMonth()]} {fulldate.getFullYear()}
          </SociollaText>
          <TouchableOpacity
            testID={`${testID}-next-month-btn`}
            style={{
              width: 20,
              minWidth: 20,
              height: 14,
              paddingLeft: 10,
            }}
            activeOpacity={0.6}
            onPress={() => onNext()}>
            <Image
              style={arrowSize}
              width={arrowSize.width}
              height={arrowSize.height}
              svg={true}
              source={require('@assets/img/icons/arrow-right-grey.svg')}
            />
          </TouchableOpacity>
        </View>

        {/* Day Container */}
        <View
          style={[
            styles.rowContainer,
            {
              flexWrap: 'wrap',
              paddingHorizontal: 10,
              paddingTop: 10,
            },
          ]}>
          {days.map((item, idx) => (
            <TouchableOpacity
              key={idx}
              activeOpacity={0.6}
              style={[styles.dateSize, styles.rowCenter]}>
              <SociollaText
                type="bold"
                style={{
                  fontSize: 12,
                  color: Colors.grey1,
                }}>
                {item[0]}
              </SociollaText>
            </TouchableOpacity>
          ))}
        </View>

        {/* Date List */}
        <View
          style={[
            styles.rowContainer,
            {
              flexWrap: 'wrap',
              paddingHorizontal: 10,
              paddingBottom: 10,
            },
          ]}>
          {lists.map((item, idx) => {
            return item.map((result, child_idx) => (
              <TouchableOpacity
                testID={`${testID}-date-${idx}-${child_idx}`}
                key={`${idx}-${child_idx}`}
                activeOpacity={0.6}
                style={[
                  styles.dateSize,
                  styles.rowCenter,
                  { borderRadius: 60 },
                  !isNative
                    ? {
                        height: dateHeight,
                      }
                    : {},
                  isActive(result)
                    ? {
                        backgroundColor: Colors.blue0,
                      }
                    : {},
                  isToday(result) && !isActive(result)
                    ? {
                        borderColor: Colors.blue0,
                        borderWidth: 1,
                      }
                    : {},
                ]}
                onPress={() =>
                  result
                    ? setSelected(
                        new Date(
                          result.getFullYear(),
                          result.getMonth(),
                          checkDate(result),
                        ),
                      )
                    : false
                }
                onLayout={onLayoutItem}
                disabled={isDisableDate(result)}>
                <SociollaText
                  type={isActive(result) ? 'bold' : 'regular'}
                  style={{
                    fontSize: 12,
                    ...(isActive(result)
                      ? {
                          color: Colors.white,
                        }
                      : {}),
                    ...(isDisableDate(result)
                      ? {
                          color: Colors.grey1,
                        }
                      : {}),
                  }}>
                  {checkDate(result, 'getDate', true)}
                </SociollaText>
              </TouchableOpacity>
            ));
          })}
        </View>

        {/* Button Container */}
        <View
          style={[
            styles.rowContainer,
            {
              justifyContent: 'flex-end',
              paddingVertical: 10,
            },
          ]}>
          <TouchableOpacity
            testID={`${testID}-cancel-btn`}
            activeOpacity={0.6}
            style={styles.btnDate}
            onPress={() => onClose()}>
            <SociollaText
              type="bold"
              style={[styles.btnText, { color: Colors.blue1 }]}>
              CANCEL
            </SociollaText>
          </TouchableOpacity>
          <TouchableOpacity
            testID={`${testID}-select-btn`}
            activeOpacity={0.6}
            style={styles.btnDate}
            onPress={() => onChange()}
            disabled={isDisableDate(selected)}>
            <SociollaText
              type="bold"
              style={[
                styles.btnText,
                {
                  color: isDisableDate(selected) ? Colors.grey1 : Colors.blue0,
                },
              ]}>
              SELECT
            </SociollaText>
          </TouchableOpacity>
        </View>
        <PortalHost name="portal_year" />
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  datepicker: {
    width: isNative ? dimension.width - 70 : '100%',
    borderRadius: 5,
    overflow: 'hidden',
    borderWidth: 0,
    backgroundColor: Colors.white,
    marginLeft: isNative ? 35 : 'auto',
    marginTop: isNative ? '20%' : 0,
  },
  datepickerTop: {
    width: '100%',
    alignItems: 'flex-start',
    backgroundColor: Colors.black,
    paddingHorizontal: 15,
    paddingTop: 25,
    paddingBottom: 20,
  },
  // eslint-disable-next-line react-native/no-color-literals
  yearContainer: {
    marginBottom: 5,
    paddingHorizontal: 5,
    paddingVertical: 2,
    borderRadius: 2,
    backgroundColor: '#131313',
  },
  yearText: {
    fontSize: 14,
    color: Colors.grey0,
    lineHeight: 20,
  },
  dateText: {
    fontSize: 18,
    color: Colors.white,
  },
  rowContainer: {
    width: '100%',
    flexDirection: 'row',
  },
  rowCenter: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dateSize: {
    width: isNative ? (dimension.width - 105) / 7 : '14.28%',
    minWidth: isNative ? (dimension.width - 105) / 7 : '14.28%',
    height: isNative ? (dimension.width - 105) / 7 : 30,
  },
  btnDate: {
    paddingHorizontal: 15,
    paddingVertical: 15,
  },
  btnText: {
    fontSize: 13,
    letterSpacing: 0.5,
  },
});

export default React.memo(SociollaDatePicker, (prev, next) => prev == next);
